import type { Home } from '@lmc/ts-common'
import useFeatureFlags from 'hooks/useFeatureFlags'
import useHomeType from 'hooks/useHomeType'
import type { FC } from 'react'
import { useSelector } from 'react-redux'
import TeamMemberProfileScreen from './TeamMemberProfileScreen'

export const TeamMemberProfileScreenRedirect: FC = () => {
  const home = useSelector(
    (state: { global: { home: Home } }) => state.global.home
  )

  const { hasRota } = useHomeType()

  const flags = useFeatureFlags({
    flagNames: [
      'team_member',
      'outcomes_and_goals_v2',
      'keyworkers',
      'group_access_management'
    ]
  })?.data
  const teamMemberEnabled = flags?.team_member?.enabled
  const isRosteringBetaEnabled = hasRota

  const flagsKeyworkersEnabled = flags?.keyworkers?.enabled

  const keyworkersEnabled =
    flagsKeyworkersEnabled && home?.features?.goals?.enabled

  return (
    <TeamMemberProfileScreen
      teamMemberEnabled={teamMemberEnabled}
      isRosteringBetaEnabled={isRosteringBetaEnabled}
      keyworkersEnabled={keyworkersEnabled}
    />
  )
}
